// General
import { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { setCookie } from "../../../../services/cookie.service";
// Redux
import { useDispatch } from "react-redux";
import { updateUtmSource } from "../../../../redux/store/trackingStore";

const UtmMounted = () => {
  // Redux variables
  const dispatch = useDispatch();

  // Router variables
  let location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  // Lifecycle | Mounted
  useEffect(() => {
    checkUtmFromUrl();
  }, []);

  const checkUtmFromUrl = () => {
    let utmData = {
      rawSearchParam: isUtmValid(location.search),
      stringyfiedSearchParam: convertQueryStringToJson(searchParams.toString()),
      organizedUtmSource: {},
    };

    // Capture any "utm_" param present in the URL (not just a fixed list)
    searchParams.forEach((value, key) => {
      if (key.startsWith("utm_") && value) {
        utmData[key] = value;
        utmData.organizedUtmSource[key] = value;
      }
    });

    if (utmData?.rawSearchParam) {
      setCookie("utm_data", JSON.stringify(utmData), 60);
      dispatch(updateUtmSource(utmData));
    }
  };

  // Utility Functions
  const convertQueryStringToJson = (queryString) => {
    // Split the query string into an array of parameter-value pairs
    const queryParams = queryString.split("&");

    // Create an empty object to store the parameters and values
    const jsonResult = {};

    // Iterate through each parameter-value pair and add them to the object
    queryParams.forEach((param) => {
      const [key, value] = param.split("=");
      jsonResult[key] = value;
    });

    // Convert the object to a JSON string
    const jsonString = JSON.stringify(jsonResult);

    return jsonString;
  };
  const isUtmValid = (searchParam) => {
    if (searchParam?.includes("utm_")) {
      return searchParam;
    } else {
      return "";
    }
  };

  return <div id="utm-mounted-shadow-component"></div>;
};

export default UtmMounted;
